module.exports = __webpack_public_path__ + "img/logo_le-lys-bleu.35b5492a.png";